var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.image.type === "Mobile Device"
    ? _c(
        "div",
        { staticClass: "device device--mobile" },
        [
          _c("Picture", {
            attrs: { image: _vm.image, "is-inline": _vm.inline },
          }),
        ],
        1
      )
    : _vm.image.type === "Desktop Device"
    ? _c(
        "div",
        { staticClass: "device device--laptop" },
        [
          _c("Picture", {
            attrs: { image: _vm.image, "is-inline": _vm.inline },
          }),
        ],
        1
      )
    : _vm.image.type === "Right Aligned"
    ? _c(
        "div",
        { staticClass: "float-right clearfix" },
        [
          _c("Picture", {
            attrs: { image: _vm.image, "is-inline": _vm.inline },
          }),
        ],
        1
      )
    : _vm.image.type === "Inline"
    ? _c(
        "div",
        [
          _vm.image.href
            ? _c(
                "LocaleLink",
                { attrs: { link: _vm.image.href } },
                [
                  _c("Picture", {
                    attrs: {
                      image: _vm.image,
                      "is-inline": _vm.inline,
                      classes: "float-left clearfix pr-1/2",
                    },
                  }),
                ],
                1
              )
            : _c("Picture", {
                attrs: {
                  image: _vm.image,
                  "is-inline": _vm.inline,
                  classes: "float-left clearfix pr-1/2",
                },
              }),
        ],
        1
      )
    : _vm.image.type === "Grow"
    ? _c(
        "div",
        [
          _vm.image.href
            ? _c(
                "LocaleLink",
                { attrs: { link: _vm.image.href } },
                [
                  _c("Picture", {
                    attrs: {
                      image: _vm.image,
                      "is-inline": _vm.inline,
                      "custom-scale": "?fit=pad&w=300&h=225&fm=jpg&q=60",
                      classes:
                        "duration-200 transition-all rounded-sm hover--shadow-scale mb-1",
                    },
                  }),
                ],
                1
              )
            : _c("Picture", {
                attrs: {
                  image: _vm.image,
                  "is-inline": _vm.inline,
                  "custom-scale": "?fit=pad&w=300&h=225&fm=jpg&q=60",
                  classes:
                    "duration-200 transition-all rounded-sm hover--shadow-scale mb-1",
                },
              }),
        ],
        1
      )
    : _vm.image.href
    ? _c(
        "LocaleLink",
        { attrs: { link: _vm.image.href } },
        [
          _c("Picture", {
            attrs: { image: _vm.image, "is-inline": _vm.inline },
          }),
        ],
        1
      )
    : _c("Picture", { attrs: { image: _vm.image, "is-inline": _vm.inline } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }